
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, class_type, record_type, list_type, option_type, float64_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, StorageId__get_unwrap, FormState__setValidationResponse_5219762A, FormState__startLoading, ToolId__get_unwrap, RequestedValue$1, FormState_get_empty, TokenDataDto_$reflection, RequestedValue$1_$reflection, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { ToolTypes_$reflection } from "../../Shared/Tool.js";
import { MultiStateUpdateDto, MultiStateUpdateDto_$reflection } from "../../Shared/MultiOperation.js";
import { find, toArray as toArray_1, length, choose, collect, singleton as singleton_1, append as append_1, contains, ofArray, filter, map, empty, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { toArray, empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { getSelectedSets } from "../../Requests/Set.js";
import { Cmd_getSelectedTools } from "../../Requests/Tool.js";
import { unwrap, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toISOString } from "../../Common.js";
import { createObj, stringHash, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FSharpMap__get_IsEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { InvalidTextValue } from "../../Components/Text.js";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import { Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { TabsMenu } from "../TabsMenu.js";
import { TableControl$1, Table as Table_1 } from "../Table/Table.js";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { Select } from "../../Components/Select.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextArea } from "../../Components/TextArea.js";
import { Button } from "../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";

export class TableElementType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Consumable", "Set"];
    }
}

export function TableElementType_$reflection() {
    return union_type("Widgets.Modals.MultiUpdateStateModal.TableElementType", [], TableElementType, () => [[], [], [], []]);
}

export class TableElement extends Record {
    constructor(Id, ElementId, Manufacturer, Model, Name, AdditionalName, InventoryNumber, Quantity, Type, Unit, SelectedStorageId, Storage, StorageSpace, CurrentState, AvailableStorageIds) {
        super();
        this.Id = Id;
        this.ElementId = ElementId;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.Name = Name;
        this.AdditionalName = AdditionalName;
        this.InventoryNumber = InventoryNumber;
        this.Quantity = Quantity;
        this.Type = Type;
        this.Unit = Unit;
        this.SelectedStorageId = SelectedStorageId;
        this.Storage = Storage;
        this.StorageSpace = StorageSpace;
        this.CurrentState = CurrentState;
        this.AvailableStorageIds = AvailableStorageIds;
    }
}

export function TableElement_$reflection() {
    return record_type("Widgets.Modals.MultiUpdateStateModal.TableElement", [], TableElement, () => [["Id", string_type], ["ElementId", string_type], ["Manufacturer", string_type], ["Model", string_type], ["Name", string_type], ["AdditionalName", string_type], ["InventoryNumber", string_type], ["Quantity", option_type(float64_type)], ["Type", TableElementType_$reflection()], ["Unit", string_type], ["SelectedStorageId", option_type(string_type)], ["Storage", string_type], ["StorageSpace", string_type], ["CurrentState", string_type], ["AvailableStorageIds", list_type(string_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetStateDate", "SetComment", "SetNewState", "Save", "AddElement", "RemoveElement", "InitTableElements", "StateUpdateResponse", "SetsFetched", "ToolsFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Modals.MultiUpdateStateModal.Msg", [], Msg, () => [[["Item", option_type(class_type("System.DateTime"))]], [["Item", string_type]], [["Item", string_type]], [], [["ids", list_type(string_type)]], [["ids", list_type(string_type)]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(DataTransfer_DetailSet_$reflection())]], [["Item", list_type(ToolTypes_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(FormState, SuccessCallback, OnClose, Sets, Tools, TableElements, RemovedElements, Dto, SelectedStateDate, UserData) {
        super();
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Sets = Sets;
        this.Tools = Tools;
        this.TableElements = TableElements;
        this.RemovedElements = RemovedElements;
        this.Dto = Dto;
        this.SelectedStateDate = SelectedStateDate;
        this.UserData = UserData;
    }
}

function State_$reflection() {
    return record_type("Widgets.Modals.MultiUpdateStateModal.State", [], State, () => [["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Sets", RequestedValue$1_$reflection(list_type(DataTransfer_DetailSet_$reflection()))], ["Tools", RequestedValue$1_$reflection(list_type(ToolTypes_$reflection()))], ["TableElements", list_type(TableElement_$reflection())], ["RemovedElements", list_type(TableElement_$reflection())], ["Dto", MultiStateUpdateDto_$reflection()], ["SelectedStateDate", option_type(class_type("System.DateTime"))], ["UserData", TokenDataDto_$reflection()]]);
}

function init(successCallback, onClose, userData, toolProps) {
    return [new State(FormState_get_empty(), successCallback, onClose, isEmpty(toolProps.SetIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), isEmpty(toolProps.ToolIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), empty(), empty(), new MultiStateUpdateDto(empty(), empty(), empty(), "active", undefined, ""), undefined, userData), Cmd_batch(toList(delay(() => append(!isEmpty(toolProps.SetIds) ? singleton(getSelectedSets(toolProps.SetIds, (Item) => (new Msg(8, [Item])), (Item_1) => (new Msg(10, [Item_1])))) : empty_1(), delay(() => (!isEmpty(toolProps.ToolIds) ? singleton(Cmd_getSelectedTools(map(ToolId__get_unwrap, toolProps.ToolIds), (Item_2) => (new Msg(9, [Item_2])), (Item_3) => (new Msg(10, [Item_3])))) : empty_1()))))))];
}

function setLabelByState(newState) {
    switch (newState) {
        case "inMaintenance":
            return "general.in_maintenance";
        case "retired":
            return "general.retired";
        case "lost":
            return "general.lost";
        default:
            return "general.active";
    }
}

function toolLabelByState(newState) {
    switch (newState) {
        case "inMaintenance":
            return "general.in_maintenance";
        case "retired":
            return "general.retired";
        case "lost":
            return "general.lost";
        default:
            return "general.active";
    }
}

function toolWithQuantityLabelByState(newState) {
    if (newState.tag === 1) {
        return "general.retired";
    }
    else {
        return "general.active";
    }
}

function update(msg, state) {
    let bind$0040, bind$0040_1;
    switch (msg.tag) {
        case 1:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, (bind$0040 = state.Dto, new MultiStateUpdateDto(bind$0040.SetIds, bind$0040.ToolIds, bind$0040.ToolWithQuantityIds, bind$0040.NewState, bind$0040.StateDate, msg.fields[0])), state.SelectedStateDate, state.UserData), Cmd_none()];
        case 2:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_1 = state.Dto, new MultiStateUpdateDto(bind$0040_1.SetIds, bind$0040_1.ToolIds, bind$0040_1.ToolWithQuantityIds, msg.fields[0], bind$0040_1.StateDate, bind$0040_1.Comment)), state.SelectedStateDate, state.UserData), Cmd_none()];
        case 3: {
            let stateDateString;
            const matchValue = state.Dto.NewState;
            switch (matchValue) {
                case "inMaintenance":
                case "lost":
                case "retired": {
                    stateDateString = map_1(toISOString, state.SelectedStateDate);
                    break;
                }
                default:
                    stateDateString = undefined;
            }
            let updatedDto;
            const bind$0040_2 = state.Dto;
            const ToolIds = map((_arg) => _arg.ElementId, filter((element) => equals(element.Type, new TableElementType(0, [])), state.TableElements));
            updatedDto = (new MultiStateUpdateDto(map((_arg_1) => _arg_1.ElementId, filter((element_1) => equals(element_1.Type, new TableElementType(3, [])), state.TableElements)), ToolIds, map((_arg_2) => _arg_2.ElementId, filter((element_2) => equals(element_2.Type, new TableElementType(1, [])), state.TableElements)), bind$0040_2.NewState, stateDateString, bind$0040_2.Comment));
            return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.SelectedStateDate, state.UserData), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/multi-operations/state", toString(0, Auto_generateBoxedEncoder_437914C6(MultiStateUpdateDto_$reflection(), undefined, undefined, undefined)(updatedDto))], (Item) => (new Msg(7, [Item])), (Item_1) => (new Msg(10, [Item_1])))];
        }
        case 7: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0]), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.SelectedStateDate, state.UserData), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.SelectedStateDate, state.UserData), Cmd_batch(ofArray([Cmd_ofEffect((_arg_3) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_4) => {
                    state.OnClose();
                })]))];
            }
        }
        case 4: {
            const addedElements = msg.fields[0];
            const selectedElement = filter((tableElement) => contains(tableElement.Id, addedElements, {
                Equals: (x_1, y) => (x_1 === y),
                GetHashCode: (x_1) => (stringHash(x_1) | 0),
            }), state.RemovedElements);
            const updatedRemovedElements = filter((tableElement_1) => !contains(tableElement_1.Id, addedElements, {
                Equals: (x_2, y_1) => (x_2 === y_1),
                GetHashCode: (x_2) => (stringHash(x_2) | 0),
            }), state.RemovedElements);
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, append_1(selectedElement, state.TableElements), updatedRemovedElements, state.Dto, state.SelectedStateDate, state.UserData), Cmd_none()];
        }
        case 5: {
            const removedElements = msg.fields[0];
            const selectedElement_1 = filter((tableElement_2) => contains(tableElement_2.Id, removedElements, {
                Equals: (x_3, y_2) => (x_3 === y_2),
                GetHashCode: (x_3) => (stringHash(x_3) | 0),
            }), state.TableElements);
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, filter((tableElement_3) => !contains(tableElement_3.Id, removedElements, {
                Equals: (x_4, y_3) => (x_4 === y_3),
                GetHashCode: (x_4) => (stringHash(x_4) | 0),
            }), state.TableElements), append_1(selectedElement_1, state.RemovedElements), state.Dto, state.SelectedStateDate, state.UserData), Cmd_none()];
        }
        case 8:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.SelectedStateDate, state.UserData), singleton_1((dispatch) => {
                dispatch(new Msg(6, []));
            })];
        case 9:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, new RequestedValue$1(1, [msg.fields[0]]), state.TableElements, state.RemovedElements, state.Dto, state.SelectedStateDate, state.UserData), singleton_1((dispatch_1) => {
                dispatch_1(new Msg(6, []));
            })];
        case 6: {
            const matchValue_1 = state.Tools;
            const matchValue_2 = state.Sets;
            let matchResult, sets, tools;
            if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_2.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                sets = matchValue_2.fields[0];
                tools = matchValue_1.fields[0];
            }
            switch (matchResult) {
                case 0: {
                    const setElements = map((set$) => (new TableElement(newGuid(), set$.Id, set$.MasterData.Manufacturer, set$.MasterData.Model, set$.MasterData.Name, "", set$.MasterData.InventoryNumber, undefined, new TableElementType(3, []), "piece", set$.LocationInformation.StorageId, set$.LocationInformation.StorageName, set$.LocationInformation.StorageSpace, setLabelByState(set$.State), empty())), sets);
                    const setAssignedToolIds = collect((x_5) => x_5, map((set$_1) => map((_arg_5) => _arg_5.ToolId, set$_1.AssignedTools), sets));
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, append_1(setElements, choose((tool) => {
                        if (tool.tag === 1) {
                            const tool_2 = tool.fields[0];
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_2.Id), tool_2.Manufacturer, tool_2.Model, tool_2.DisplayName, "", tool_2.InventoryNumber, undefined, new TableElementType(1, []), "piece", undefined, "", "", toolWithQuantityLabelByState(tool_2.State), empty());
                        }
                        else {
                            const tool_1 = tool.fields[0];
                            if (contains(ToolId__get_unwrap(tool_1.Id), setAssignedToolIds, {
                                Equals: (x_6, y_4) => (x_6 === y_4),
                                GetHashCode: (x_6) => (stringHash(x_6) | 0),
                            })) {
                                return undefined;
                            }
                            else {
                                return new TableElement(newGuid(), ToolId__get_unwrap(tool_1.Id), tool_1.Manufacturer, tool_1.Model, tool_1.DisplayName, "", tool_1.InventoryNumber, undefined, new TableElementType(0, []), "piece", StorageId__get_unwrap(tool_1.StorageId), "", tool_1.StorageSpace, toolLabelByState(tool_1.State), empty());
                            }
                        }
                    }, tools)), state.RemovedElements, state.Dto, state.SelectedStateDate, state.UserData), Cmd_none()];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 10:
            return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.SelectedStateDate, state.UserData), Cmd_none()];
        default:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, msg.fields[0], state.UserData), Cmd_none()];
    }
}

function Table(props) {
    let elems_1;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const columnDefinition = toArray(delay(() => append(!FSharpMap__get_IsEmpty(props.FormState.Validations) ? singleton(new ColumnDefinition$1("hint", "", t("assign_multiple_tools_dialog.hint"), (row) => {
        const matchValue = FormState__getValidation(props.FormState, t, concat(row.ElementId, ..."-validation-tool-assigned-to-user"));
        const matchValue_1 = FormState__getValidation(props.FormState, t, concat(row.ElementId, ..."-validation-set-assigned-to-user"));
        let matchResult, value;
        if (matchValue != null) {
            matchResult = 0;
            value = matchValue;
        }
        else if (matchValue_1 != null) {
            matchResult = 0;
            value = matchValue_1;
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return new CellContent(1, [createElement(InvalidTextValue, {
                    TestId: concat(row.Id, ..."-validation-message"),
                    Text: value,
                })]);
            default:
                return new CellContent(0, [""]);
        }
    }, "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("assign_multiple_tools_dialog.manufacturer"), (row_1) => (new CellContent(0, [row_1.Manufacturer])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("assign_multiple_tools_dialog.model"), (row_2) => (new CellContent(0, [row_2.Model])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("tool.displayname"), (row_3) => (new CellContent(0, [row_3.Name])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("assign_multiple_tools_dialog.inventory_number"), (row_4) => (new CellContent(0, [row_4.InventoryNumber])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("state", "", t("general.state"), (row_5) => (new CellContent(0, [t(row_5.CurrentState)])), "none", "text")), delay(() => singleton(new ColumnDefinition$1("unit", "", t("general.unit"), (row_6) => (new CellContent(0, [t(Helper_unitToTranslationKey(row_6.Unit))])), "none", "text"))))))))))))))));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_1 = toList(delay(() => {
        let elems, arg_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "mb-4"])], (elems = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: props.IsAddedElementTabVisible,
                Label: t("assign_multiple_tools_dialog.tools"),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(true);
                },
                TestId: "",
            }, {
                IsSelected: !props.IsAddedElementTabVisible,
                Label: (arg_1 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, patternInput[1].t("assign_multiple_tools_dialog.removed_elements", arg_1)),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(false);
                },
                TestId: "",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let TableRows, Options, TableRows_1, Options_1;
            return props.IsAddedElementTabVisible ? singleton(createElement(Table_1, (TableRows = toArray_1(props.TableElements), (Options = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["manufacturer", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "multiRow",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: columnDefinition,
                Controls: singleton_1(new TableControl$1(t("general.remove"), Recycle_Bin_1(), (rows) => {
                    props.Dispatch(new Msg(5, [map((_arg_2) => _arg_2.Id, rows)]));
                }, true, false, "tools-dialog-toolreservation-dialog-remove-button")),
                Options: Options,
                TableKey: "not-defined-table",
                TableRows: TableRows,
            })))) : singleton(createElement(Table_1, (TableRows_1 = toArray_1(props.RemovedElements), (Options_1 = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["manufacturer", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "multiRow",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: columnDefinition,
                Controls: singleton_1(new TableControl$1(t("general.remove"), Recycle_Bin_1(), (rows_1) => {
                    props.Dispatch(new Msg(4, [map((_arg_3) => _arg_3.Id, rows_1)]));
                }, true, false, "tools-dialog-toolreservation-dialog-remove-button")),
                Options: Options_1,
                TableKey: "not-defined-table",
                TableRows: TableRows_1,
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function labelByState(t, newState) {
    switch (newState) {
        case "inMaintenance":
            return t("general.in_maintenance");
        case "retired":
            return t("tool.retire_tool");
        case "lost":
            return t("tool.lost_tool");
        default:
            return t("tool.state_active");
    }
}

function Form(props) {
    let elems_1;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const stateOptions = ofArray([{
        label: labelByState(t, "active"),
        value: "active",
    }, {
        label: labelByState(t, "inMaintenance"),
        value: "inMaintenance",
    }, {
        label: labelByState(t, "retired"),
        value: "retired",
    }, {
        label: labelByState(t, "lost"),
        value: "lost",
    }]);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4", "mt-4", "w-96"])], (elems_1 = toList(delay(() => {
        let Label, Value;
        return append(singleton(createElement(Select, (Label = t("multi_operation.change_state.new_state"), (Value = find((option_2) => (option_2.value === props.Dto.NewState), stateOptions), {
            ComponentState: componentState,
            IsClearable: false,
            Label: unwrap(Label),
            NoOptionsMessage: "",
            OnChange: (option) => {
                if (option == null) {
                }
                else {
                    props.Dispatch(new Msg(2, [option.value]));
                }
            },
            Options: stateOptions,
            PlaceholderKey: "",
            TestId: "switch-storage-dialog-storage-target-test-id",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "storage")),
            Value: unwrap(Value),
        })))), delay(() => {
            let matchValue;
            return append((matchValue = props.Dto.NewState, (matchValue === "inMaintenance") ? singleton(createElement(DatePicker, {
                ComponentState: componentState,
                IsClearable: true,
                Label: (props.Dto.NewState === "inMaintenance") ? t("tool.maintenance_planned_end_date") : t("general.date"),
                OnChange: (arg) => {
                    props.Dispatch(new Msg(0, [arg]));
                },
                TestId: "multi-update-state-test-id",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "date")),
                Value: unwrap(props.SelectedDate),
            })) : ((matchValue === "retired") ? singleton(createElement(DatePicker, {
                ComponentState: componentState,
                IsClearable: true,
                Label: (props.Dto.NewState === "inMaintenance") ? t("tool.maintenance_planned_end_date") : t("general.date"),
                OnChange: (arg) => {
                    props.Dispatch(new Msg(0, [arg]));
                },
                TestId: "multi-update-state-test-id",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "date")),
                Value: unwrap(props.SelectedDate),
            })) : ((matchValue === "lost") ? singleton(createElement(DatePicker, {
                ComponentState: componentState,
                IsClearable: true,
                Label: (props.Dto.NewState === "inMaintenance") ? t("tool.maintenance_planned_end_date") : t("general.date"),
                OnChange: (arg) => {
                    props.Dispatch(new Msg(0, [arg]));
                },
                TestId: "multi-update-state-test-id",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "date")),
                Value: unwrap(props.SelectedDate),
            })) : (empty_1())))), delay(() => append(singleton(createElement(TextArea, {
                ComponentState: componentState,
                Label: t("general.comment"),
                OnChange: (arg_1) => {
                    props.Dispatch(new Msg(1, [arg_1]));
                },
                TestId: "multi-update-state-test-id",
                Value: props.Dto.Comment,
            })), delay(() => {
                let elems, Label_3;
                return singleton(reactElement("div", createObj(singleton_1((elems = [createElement(Button, (Label_3 = t("general.save"), {
                    ComponentState: (componentState === "disabled") ? "disabled" : (props.IsTableElementsEmpty ? "disabled" : "enabled"),
                    Label: Label_3,
                    OnClick: () => {
                        props.Dispatch(new Msg(3, []));
                    },
                    TestId: "multiple-switch-storage-save-button",
                    Variant: "primary",
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])))));
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function Content(props) {
    let elems_2, elems_1;
    const patternInput = useTranslation();
    const patternInput_1 = reactApi.useState(true);
    const isAddedElementsTabSelected = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["min-h-48"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4"])], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(Table, {
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            IsAddedElementTabVisible: isAddedElementsTabSelected,
            RemovedElements: props.RemovedElements,
            SetIsAddedElementTabVisible: patternInput_1[1],
            TableElements: props.TableElements,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (isAddedElementsTabSelected ? singleton(createElement(Form, {
            Dispatch: props.Dispatch,
            Dto: props.Dto,
            FormState: props.FormState,
            IsTableElementsEmpty: isEmpty(props.TableElements),
            SelectedDate: unwrap(props.SelectedDate),
        })) : empty_1())));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function MultiUpdateStateModalSheet(props) {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SuccessCallback, props.OnClose, props.UserData, props.ToolProps), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput[0];
    const patternInput_1 = useTranslation();
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (state_1.Sets.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((state_1.Tools.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(Content, {
            Dispatch: patternInput[1],
            Dto: state_1.Dto,
            FormState: state_1.FormState,
            RemovedElements: state_1.RemovedElements,
            SelectedDate: unwrap(state_1.SelectedStateDate),
            TableElements: state_1.TableElements,
        })),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: patternInput_1[0]("multi_operation.change_state.title"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

